var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('InPageNavigationMobile',{attrs:{"disabled":_vm.disabled,"loading":_vm.loading,"items":_vm.items}}),_c('InPageNavigationDesktop',{attrs:{"disabled":_vm.disabled,"loading":_vm.loading,"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }